import type * as React from 'react';

import { Description, FieldGroup, Switch, TooltipIndicator } from '@gitbook/spine-react';

import type { PageLayoutOptionsProps } from './types';

/**
 * Options to footer (Next/Prev links) visibility on a page.
 */
export function PageOptionsFooter(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;
    return (
        <div className="flex flex-1 flex-col gap-2">
            <FieldGroup orientation="horizontal">
                <Description className="flex items-center gap-1">
                    <span>Pagination</span>
                    <TooltipIndicator
                        label="When published as a site, also enable pagination in the site's customization settings"
                        className="size-3"
                    />
                </Description>
                <Switch
                    value={!!pageOptions.layoutOptions.pagination}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                pagination: value,
                            },
                        })
                    }
                />
            </FieldGroup>
            <FieldGroup orientation="horizontal">
                <Description className="flex items-center gap-1">
                    <span>Page metadata</span>
                    <TooltipIndicator
                        label="Show 'Last modified' timestamp and other metadata in the page footer"
                        className="size-3"
                    />
                </Description>
                <Switch
                    value={pageOptions.layoutOptions.metadata !== false}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                metadata: value,
                            },
                        })
                    }
                />
            </FieldGroup>
        </div>
    );
}
